// DONM3/services/frontend/src/utils/dataTransform.js
export class DataTransform {
  static hierarchyToOrgChart(data) {
    if (!Array.isArray(data) || data.length === 0) {
      console.warn('Нет данных для трансформации')
      return []
    }

    console.log('Трансформация данных без виртуального корня:', data.length, 'записей')
    console.log('Образец исходных данных:', data.slice(0, 3))
    
    const nodeMap = new Map()
    
    // Создаем все узлы с правильной обработкой ID
    data.forEach((item, index) => {
      // ИСПРАВЛЕНИЕ: Используем именно item.id, а не item.childid
      const nodeId = String(item.id !== null && item.id !== undefined ? item.id : `node-${index}`)
      const parentId = item.parentid !== null && item.parentid !== undefined ? String(item.parentid) : null
      
      const node = {
        id: nodeId,
        parentId: parentId,
        name: item.name || 'Без имени',
        position: item.positionname || item.position || '', // Используем positionname
        email: item.email || '',
        phone: item.phone || '',
        department: item.department || '',
        imageurl: item.imageurl || '',
        biography: item.biography || '',
        originalData: item
      }
      
      console.log('Узел создан:', {
        id: node.id,
        parentId: node.parentId,
        name: node.name,
        originalId: item.id,
        originalParentId: item.parentid
      })
      
      nodeMap.set(nodeId, node)
    })
    
    // Находим корневые узлы
    const realRoots = []
    const allIds = new Set(Array.from(nodeMap.keys()))
    
    nodeMap.forEach(node => {
      const hasValidParent = node.parentId && allIds.has(node.parentId)
      if (!hasValidParent) {
        realRoots.push(node)
        console.log('Корневой узел:', node.name, 'ID:', node.id, 'parentId:', node.parentId)
      }
    })
    
    console.log('Найдено корневых узлов:', realRoots.length)
    console.log('Все ID в системе:', Array.from(allIds).sort())
    
    // Если Каклюгина есть, делаем её единственным корнем
    const kaklyugina = nodeMap.get('0')
    if (kaklyugina && realRoots.length > 1) {
      console.log('Каклюгина найдена:', kaklyugina.name)
      
      // Убираем parentId у Каклюгиной
      kaklyugina.parentId = null
      
      // Для остальных корней (кроме Каклюгиной) ставим parentId на Каклюгину
      realRoots.forEach(node => {
        if (node.id !== '0') {
          console.log(`Переназначаем родителя для ${node.name}: ${node.parentId} → 0`)
          node.parentId = '0'
        }
      })
      
      console.log('Каклюгина установлена как единственный корень')
    } else if (!kaklyugina) {
      console.error('Каклюгина не найдена! Доступные узлы:', Array.from(nodeMap.keys()))
    }
    
    const result = Array.from(nodeMap.values())
    
    // Проверяем отсутствующих родителей
    const missingParents = []
    result.forEach(node => {
      if (node.parentId && !nodeMap.has(node.parentId)) {
        missingParents.push(`${node.name} ищет родителя "${node.parentId}"`)
      }
    })
    
    if (missingParents.length > 0) {
      console.error('Отсутствующие родители:', missingParents)
    }
    
    console.log('Финальная структура:', {
      total: result.length,
      roots: result.filter(n => n.parentId === null).length,
      kaklyuginaChildren: result.filter(n => n.parentId === '0').length,
      sampleHierarchy: result.slice(0, 5).map(n => ({
        id: n.id,
        parentId: n.parentId,
        name: n.name
      }))
    })
    
    return result
  }

  static hierarchyToD3Format(data) {
    return this.hierarchyToOrgChart(data)
  }

  static findNodeById(nodes, id) {
    for (const node of nodes) {
      if (node.id === id) return node
      if (node.children && node.children.length > 0) {
        const found = this.findNodeById(node.children, id)
        if (found) return found
      }
    }
    return null
  }

  static searchNodes(nodes, query) {
    if (!query || query.trim() === '') return nodes
    
    const lowerQuery = query.toLowerCase().trim()
    const results = []
    
    const searchRecursive = (nodeList) => {
      nodeList.forEach(node => {
        const matches = 
          node.name.toLowerCase().includes(lowerQuery) ||
          node.position.toLowerCase().includes(lowerQuery) ||
          node.department.toLowerCase().includes(lowerQuery)
        
        if (matches) {
          results.push(node)
        }
        
        if (node.children && node.children.length > 0) {
          searchRecursive(node.children)
        }
      })
    }
    
    searchRecursive(nodes)
    return results
  }
}
